
import React, { useState } from 'react';
import { useAuth } from '../context/useAuth';
import { hasPermission } from '../utils/permissions';
import { Tabs, Tab, Box } from '@mui/material';
import PlatformGeneralSettings from './PlatformGeneralSettings.jsx';
import GlobalIntegrationsSettings from './GlobalIntegrationsSettings.jsx';
import AppearanceSettings from './AppearanceSettings.jsx';
import RelayAgentsSettings from './RelayAgentsSettings.jsx';
import { DynamicIcon } from '../components/icons.jsx';

const PlatformSettings = ({ token, currentUser }) => {
    // currentUser prop might be passed from layout, or we can use useAuth if needed, 
    // but PlatformSettings usually receives props in renderPage

    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    if (!hasPermission(currentUser, 'page:settings:view')) return <div className="p-8 text-gray-500">Access Denied</div>;

    return (
        <div className="flex flex-col h-[calc(100vh-64px)] overflow-hidden bg-slate-50 dark:bg-slate-900">
            {/* Header Area with Tabs */}
            <div className="flex-shrink-0 px-6 pt-2 pb-0 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-800">
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label="platform settings tabs"
                        sx={{
                            minHeight: '48px',
                            '& .MuiTab-root': {
                                minHeight: '48px',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                color: 'text.secondary',
                                '&.Mui-selected': { color: 'primary.main' }
                            }
                        }}
                    >
                        <Tab label="General"       id="tab-0" icon={<DynamicIcon name="Settings" className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                        <Tab label="Integrations"  id="tab-1" icon={<DynamicIcon name="Link"     className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                        <Tab label="Relay Agents"  id="tab-2" icon={<DynamicIcon name="Server"   className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                        <Tab label="Appearance"    id="tab-3" icon={<DynamicIcon name="Palette"  className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                    </Tabs>
                </Box>
            </div>

            {/* Scrollable Content Area */}
            <div className="flex-grow overflow-y-auto p-6">
                <Box role="tabpanel" hidden={activeTab !== 0}>
                    {activeTab === 0 && <PlatformGeneralSettings currentUser={currentUser} token={token} />}
                </Box>
                <Box role="tabpanel" hidden={activeTab !== 1}>
                    {activeTab === 1 && <GlobalIntegrationsSettings token={token} />}
                </Box>
                <Box role="tabpanel" hidden={activeTab !== 2}>
                    {/* tenantId omitted → platform-level agents (tenant_id IS NULL) */}
                    {activeTab === 2 && <RelayAgentsSettings token={token} />}
                </Box>
                <Box role="tabpanel" hidden={activeTab !== 3}>
                    {activeTab === 3 && <AppearanceSettings token={token} />}
                </Box>
            </div>
        </div>
    );
};

export default PlatformSettings;
